import type { addressType } from '$lib/types/util';
import { setupPresenceApiRefresh } from '$lib/data/refreshPresence';
import type { Channel } from 'pusher-js';

let Pusher: any;
const channels: {
	[channelId: string]: Channel | undefined;
} = {};

(async () => {
	if (typeof window !== 'undefined') {
		const { default: _pusher } = await import('pusher-js');
		Pusher = _pusher;
	}
})();

export let pusherObject: typeof Pusher;
export const initPusher = (address: addressType) => {
	if (address) {
		const pusherAppKey = '1b61a3aa094599636a20';
		const pusher = new Pusher(pusherAppKey, {
			cluster: 'ap1'
		});

		setupPresenceApiRefresh(address);
		pusherObject = pusher;
	}
};

export function subscribePusherChannel(channelId: string): Channel {
	if (channels[channelId]) {
		return channels[channelId] as Channel;
	} else {
		const channel = pusherObject.subscribe(channelId);
		channels[channelId] = channel;
		return channel;
	}
}

export function unsubscribePusherChannel(channelId: string) {
	if (channels[channelId]) {
		channels[channelId]!.unbind();
		channels[channelId]!.unsubscribe();
		channels[channelId] = undefined;
	}
}
